// pdf.js 5.x calls Promise.withResolvers(), which Telegram's in-app WebView only has on
// iOS 17.4+ / Chrome 119+. On older devices the call throws while <Document> renders, React
// tears down the whole tree and the user sees a blank mini app instead of the offer page.
// Imported first from index.tsx so it is installed before any module touches pdf.js.
if (typeof (Promise as any).withResolvers !== 'function') {
    (Promise as any).withResolvers = function withResolvers<T>() {
        let resolve!: (value: T | PromiseLike<T>) => void;
        let reject!: (reason?: unknown) => void;
        const promise = new Promise<T>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    };
}

if (typeof globalThis.structuredClone !== 'function') {
    globalThis.structuredClone = ((value: unknown) => JSON.parse(JSON.stringify(value))) as typeof structuredClone;
}

export {};
